import React from 'react'
import { createStyles, Checkbox, makeStyles } from '@material-ui/core'
import Typography from 'typography'
import { CheckboxOutlineBlankIcon, CheckboxIcon, IndeterminateCheckboxIcon } from 'svg-icons'

const useStyles = makeStyles(theme =>
    createStyles({
        termsAndConditions: {
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            '& label': {
                display: 'flex'
            }
        },
        labelTypography: {
            marginLeft: '5px',
            fontSize: '11px !important',
            lineHeight: '16px !important',
            '& a': {
                color: '#6E7A82',
                fontWeight: '500',
                textDecoration: 'underline',
                fontSize: '10.5px',
                lineHeight: '16px',
                letterSpacing: '0.1px'
            }
        }
    })
)

interface Props {
    disabled: boolean;

    receiveSMS: boolean;
    setReceiveSMS: (receiveSMS: boolean) => void;

    receiveSMSOffers: boolean;
    setReceiveSMSOffers: (setReceiveSMSOffers: boolean) => void;
}

const emailSupport = 'support@phone.com'

/**
 * Checkout step of sign-up
 */
const TermsAndConditions = (props: Props) : JSX.Element => {
    const classes = useStyles()

    return (
        <div className={classes.termsAndConditions}>
            <Typography
                variant="helperText"
                color="#6E7A82"
                display="block"
                align="left"
                className={classes.labelTypography}
            >
                By entering your email and/or phone number, and by checking the box below, you agree to receive automated billing and account critical emails and/or texts from Phone.com. Msg & data rates may apply. Msg freq varies. For help, email {emailSupport}. Reply STOP to opt out. <a href={process.env.REACT_APP_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">Privacy Policy</a> and <a href={process.env.REACT_APP_TERMS_OF_SERVICE_URL} target="_blank" rel="noreferrer">Terms of Service</a>.
            </Typography>

            <label>
                <Checkbox
                    data-testid="receive_sms"
                    disableRipple
                    size='small'
                    color="primary"
                    icon = {<CheckboxOutlineBlankIcon/>}
                    checkedIcon = {<CheckboxIcon/>}
                    indeterminateIcon = {<IndeterminateCheckboxIcon/>}
                    disabled={props.disabled}
                    checked={props.receiveSMS}
                    onChange={e => props.setReceiveSMS(e.target.checked)}
                />

                <Typography
                    remoteConfigID="signup_consent_to_receive_sms"
                    variant="helperText"
                    color="#6E7A82"
                    align="left"
                    className={classes.labelTypography}
                />
            </label>

            {/* <label>
                <Checkbox
                    data-testid="receive_sms_offers"
                    disableRipple
                    size='small'
                    color="primary"
                    icon = {<CheckboxOutlineBlankIcon/>}
                    checkedIcon = {<CheckboxIcon/>}
                    indeterminateIcon = {<IndeterminateCheckboxIcon/>}
                    disabled={props.disabled}
                    checked={props.receiveSMSOffers}
                    onChange={e => props.setReceiveSMSOffers(e.target.checked)}
                />

                <Typography
                    remoteConfigID="signup_consent_to_receive_sms_about_offers"
                    variant="helperText"
                    color="#6E7A82"
                    align="left"
                    className={classes.labelTypography}
                />
            </label> */}
        </div>
    )
}

export default TermsAndConditions
